import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = [ 'toggle', 'item', 'field' ]
  static classes = [ 'hidden' ]
  static values = {
    showIcon: { type: String, default: 'instant_mix' },
    hideIcon: { type: String, default: 'close' },

    usingAdvancedSearch: { type: Boolean, default: false }
  }

  connect () {
    this.class = this.hasHiddenClass ? this.hiddenClass : 'is-hidden'
    if (this.usingAdvancedSearchValue) {
      this.toggleTarget.innerHTML = this.hideIconValue
    }
  }

  toggle () {
    this.itemTargets.forEach(item => {
      item.classList.toggle(this.class)
    })

    this.clearFields()

    this.usingAdvancedSearchValue = !this.usingAdvancedSearchValue
    if (this.usingAdvancedSearchValue) {
      this.toggleTarget.innerHTML = this.hideIconValue
    } else {
      this.toggleTarget.innerHTML = this.showIconValue
    }
  }

  clearFields() {
    this.fieldTargets.forEach(field => {
      field.value = '';
      field.dispatchEvent(new Event('change'));
    });
  }
}
